<p-card styleClass="!border !border-[#dde1e6] !shadow-none !mb-8 ">
  <div class="flex justify-between">
    <p class="font-bold text-base xlplus:text-lg">Recent Conversions</p>
    @if (files().length > 0) {
    <a
      routerLink="/mbrs/xbrl-files"
      class="font-lato text-sm text-taxpod-blue font-bold"
      >View all</a
    >
    }
  </div>

  @if ( files().length > 0 && isTableLoading() === false ) {
  <div class="pt-3 flex">
    (<span class="text-red-500">*</span>)Optional: Suggestions to refine data
  </div>
  <p-table [value]="files()" styleClass="!mt-2">
    <ng-template #header>
      <tr>
        <!-- Same column-width contract as the XBRL Files listing: the
             fixed-content column (Status) carries a hard `!w-[…]`, the two
             ellipsis columns carry `!min-w-[…]` only. Auto-layout hands leftover
             width to the columns WITHOUT a specified width, so the slack lands
             in Filename/Client Company — where a wider column means less truncation.
             Turning a `!min-w-` here into a `!w-` re-breaks that. -->
        <th
          class="!bg-[#f2f3f4] !py-[5px] !px-2 font-lato text-sm xlplus:text-base !min-w-[140px] xlplus:!min-w-[180px] 2xl:!min-w-[280px]"
        >
          XBRL Filename
        </th>
        <th
          class="!bg-[#f2f3f4] !py-[5px] !px-2 font-lato text-sm xlplus:text-base !min-w-[140px] xlplus:!min-w-[160px]"
        >
          Client Company
        </th>
        <th
          class="!bg-[#f2f3f4] !py-[5px] font-lato text-sm xlplus:text-base !w-[130px] xlplus:!w-[140px]"
        >
          Status
        </th>
      </tr>
    </ng-template>
    <ng-template #body let-file>
      <tr>
        <!-- Width-based ellipsis over TWO lines, not a character count.
             `!max-w-0` on the <td> is the load-bearing bit: a filename is one
             unbroken token, so its min-content width is the whole string and an
             auto-layout table would widen the column to fit rather than clamp.
             Pinning the cell's preferred width to 0 hands column sizing to the
             <th> instead, and `w-full` then makes the span fill exactly that
             column — so the cut lands at the real column edge at any breakpoint.

             No `block`: `line-clamp-2` sets `display: -webkit-box`, and the two
             would fight over `display` by stylesheet order.

             `break-all` is NOT cosmetic, and it is deliberately NOT
             `break-words`. `-webkit-line-clamp` renders its ellipsis at a LINE
             BREAK, and a filename offers none — so without a break rule the
             token overflows sideways on a single line and gets hard-cut with no
             ellipsis at all. `break-words` (overflow-wrap: break-word) would
             cover that case but breaks a token ONLY when it cannot fit, so a
             filename containing spaces still wraps at its spaces and the cut
             lands on a word boundary with a ragged gap before the ellipsis. The
             PO asked for the cut by CHARACTER: `break-all` (word-break:
             break-all) makes every character a break opportunity, so both lines
             fill to the column edge. Covered by
             overflow-tooltip.directive.spec.ts. -->
        <td class="!px-2 !pt-2 !pb-1 align-top !max-w-0">
          <span
            appOverflowTooltip
            #fileNameClamp="overflowTooltip"
            [pTooltip]="file.fileName"
            [tooltipDisabled]="!fileNameClamp.isOverflowing()"
            tooltipPosition="top"
            tooltipStyleClass="top-tooltip"
            class="w-full line-clamp-2 break-all font-lato text-sm xlplus:text-base font-normal text-[#231f20] cursor-pointer"
          >
            {{ file.fileName }}
          </span>
        </td>
        <td
          class="font-normal text-taxpod-gray text-xs xlplus:text-base !px-2 !pt-2 !pb-1 align-top !max-w-0"
        >
          @if (file.company) {
          <!-- Real anchor: routerLink renders an href, so right-click "Open in
               New Tab", middle-click and Ctrl/Cmd+click work natively while a
               plain left-click stays SPA navigation. routerLink is set to null
               for non-terminal rows so no href (and no new-tab option) renders;
               pointer-events:none is the second guard. -->
          <!-- The tooltip lives on the wrapper, not the anchor: a non-terminal
               row sets `pointer-events: none` on the anchor, which would swallow
               the hover the tooltip needs. The wrapper also owns the ellipsis so
               the inline anchor can keep its own pointer/cursor behaviour. -->
          <span
            appOverflowTooltip
            #companyClamp="overflowTooltip"
            class="w-full line-clamp-2 break-all"
            tooltipPosition="top"
            tooltipStyleClass="top-tooltip"
            [pTooltip]="file.company | titlecase"
            [tooltipDisabled]="!companyClamp.isOverflowing()"
          >
            <a
              class="text-blue-500"
              [routerLink]="isCompanyClickable(file.status) ? ['/mbrs/filing'] : null"
              [queryParams]="{ id: file.id, companyName: file.company, fileName: file.fileName }"
              [state]="filingEntryState(file.phase)"
              [ngStyle]="{
                color: isCompanyClickable(file.status) ? '#0b8ebb' : '#5F5B5B',
                'pointer-events': isCompanyClickable(file.status) ? 'auto' : 'none',
                cursor: isCompanyClickable(file.status) ? 'pointer' : 'not-allowed'
              }"
            >
              {{ file.company | titlecase }}
            </a>
          </span>
          } @else {
          <p>-</p>
          }
        </td>
        <td class="!pt-3 align-top">
          @if (file.status === MbrsStatusEnum.PendingValidation) {
          <!-- AS-842: PendingValidation shows a skeleton while the frontend
               silently validates the conversion. The chip renders once the
               resolver emits the terminal status. -->
          <p-skeleton width="105px" height="25px"></p-skeleton>
          } @else {
          <div
            [ngClass]="conversionListingService.getStatusClass(file.status)"
            class="h-[25px] w-[105px] xlplus:w-[115px] font-lato font-bold text-xs xlplus:text-sm text-center px-3 py-1 rounded flex items-center space-x-1 justify-center"
          >
            <span
              >{{ conversionListingService.getDisplayBaseStatus(file.status)
              }}@if (conversionListingService.hasWarningAsterisk(file.status)) {<span
                  class="!text-red-500"
                  >*</span
                >}</span
            >
          </div>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
  } @else if (isTableLoading()) {
  <p-skeleton width="100%" height="200px"></p-skeleton>
  } @else {
  <div
    class="!h-[471px] xlplus:!h-[455px] 2xl:!h-[432px] flex justify-center items-center"
  >
    <div>
      <svg
        width="182"
        height="135"
        viewBox="0 0 182 135"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mx-auto"
      >
        <path
          d="M34.1108 133.326C52.8256 133.326 67.997 130.991 67.997 128.112C67.997 125.233 52.8256 122.899 34.1108 122.899C15.396 122.899 0.224609 125.233 0.224609 128.112C0.224609 130.991 15.396 133.326 34.1108 133.326Z"
          fill="#DFDFEB"
        />
        <path
          d="M89.4965 134.368C123.306 134.368 150.714 132.034 150.714 129.155C150.714 126.276 123.306 123.942 89.4965 123.942C55.6872 123.942 28.2793 126.276 28.2793 129.155C28.2793 132.034 55.6872 134.368 89.4965 134.368Z"
          fill="#DFDFEB"
        />
        <path
          d="M72.8426 0.636197C66.5212 0.808419 61.2908 5.87173 60.9272 12.1852C60.7132 15.8976 62.1519 19.2757 64.5732 21.659C64.931 22.0111 65.0972 22.5131 65.0136 23.0081L64.1044 28.3887L69.699 25.129C70.0176 24.9433 70.3929 24.8751 70.7546 24.9481C72.1222 25.224 73.571 25.2747 75.0646 25.0486C80.5912 24.2114 84.9031 19.6361 85.4128 14.0695C86.0914 6.65055 80.1658 0.436867 72.8426 0.636197Z"
          fill="#FF5353"
        />
        <g clip-path="url(#clip0_659_12884)">
          <path
            d="M75.2305 15.6771H72.2213C72.2213 12.6679 73.8262 11.6648 74.9296 11.063C75.3308 10.8624 75.6317 10.6617 75.8323 10.4611C76.3339 9.95958 76.1333 9.25742 76.033 9.05681C75.732 8.35465 75.0299 7.65249 73.7259 7.65249C71.6194 7.65249 71.2182 9.55835 71.2182 9.95958L68.209 9.55835C68.4096 7.85311 69.9142 4.64325 73.7259 4.64325C76.033 4.64325 78.0391 5.94726 78.8416 7.85311C79.5437 9.55835 79.2428 11.3639 78.0391 12.5676C77.5376 13.0691 76.9357 13.3701 76.4342 13.671C75.5314 14.1725 75.2305 14.6741 75.2305 15.6771ZM75.732 18.6864C75.7381 18.9535 75.6907 19.2192 75.5926 19.4678C75.4946 19.7164 75.3479 19.9429 75.1611 20.134C74.9743 20.3251 74.7512 20.477 74.5049 20.5807C74.2586 20.6844 73.9941 20.7378 73.7269 20.7379C73.4597 20.738 73.1951 20.6846 72.9488 20.5811C72.7025 20.4775 72.4793 20.3257 72.2924 20.1347C72.1055 19.9437 71.9587 19.7173 71.8605 19.4687C71.7624 19.2202 71.7148 18.9546 71.7207 18.6874C71.7323 18.1632 71.9487 17.6644 72.3234 17.2977C72.6982 16.9311 73.2016 16.7257 73.7259 16.7256C74.2502 16.7254 74.7537 16.9306 75.1287 17.297C75.5036 17.6635 75.7202 18.1622 75.732 18.6864Z"
            fill="white"
          />
        </g>
        <path
          d="M115.613 38.9346C115.613 38.9346 114.061 45.4241 105.282 53.3422C105.282 53.3422 104.445 52.157 106.319 47.59C108.193 43.0232 115.245 37.3154 115.613 38.9346Z"
          fill="#8BB8F9"
        />
        <path
          d="M115.611 38.9328C115.611 38.9328 107.859 43.7598 105.281 53.3404C105.281 53.3404 104.689 56.6448 105.645 59.6019"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M95.348 42.9583C95.348 42.9583 97.5285 41.5158 94.203 37.3509C91.0441 33.3943 87.6609 29.8114 80.707 28.1323C80.707 28.1323 82.2191 37.7939 86.656 40.3584C91.0932 42.9226 95.348 42.9583 95.348 42.9583Z"
          fill="#8BB8F9"
        />
        <path
          d="M77.8298 48.8678C77.8298 48.8678 85.0646 50.9386 97.7748 47.5835C97.7748 47.5835 97.0859 46.2475 91.5528 45.4584C86.0201 44.6694 76.4498 47.7059 77.8298 48.8678Z"
          fill="#8BB8F9"
        />
        <path
          d="M77.8301 48.869C77.8301 48.869 86.9319 44.773 97.7751 47.5847C97.7751 47.5847 98.8862 47.9397 99.9377 49.5493"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M83.4847 55.9057C83.4847 55.9057 91.0049 61.5775 103.715 58.2224C103.715 58.2224 101.576 53.6891 96.0433 52.9001C90.5103 52.111 82.105 54.7438 83.4847 55.9057Z"
          fill="#8BB8F9"
        />
        <path
          d="M83.4844 55.9056C83.4844 55.9056 92.2003 52.4994 103.715 58.2223C103.715 58.2223 105.067 58.9309 106.118 60.5406"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M111.676 32.4429C111.676 32.4429 114.011 32.3137 108.021 37.1825C102.364 41.7795 103.041 41.8618 103.041 41.8618C103.041 41.8618 105.541 34.6004 111.676 32.4429Z"
          fill="white"
        />
        <path
          d="M98.9961 44.1144C98.9961 44.1144 100.684 44.8926 103.989 42.2279C107.295 39.5633 108.867 33.2533 111.676 32.4426C111.676 32.4426 104.647 34.2257 98.9961 44.1144Z"
          fill="#8BB8F9"
        />
        <path
          d="M108.941 66.7791C105.875 59.4609 101.503 51.09 95.3496 42.9583C95.3496 42.9583 93.8538 40.715 88.5357 34.8074C83.2177 28.8999 80.709 28.1323 80.709 28.1323"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M110.84 32.7316C110.84 32.7316 104.103 35.1711 98.9952 44.1155C97.7577 46.2823 98.9531 48.1365 99.9366 49.5487"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M179.042 117.019C179.042 117.019 172.509 118.98 161.607 111.915C161.607 111.915 162.323 110.017 167.254 109.711C172.185 109.406 180.352 115.492 179.042 117.019Z"
          fill="#8BB8F9"
        />
        <path
          d="M178.798 116.539C178.798 116.539 171.621 110.892 161.735 111.728C161.735 111.728 158.426 112.295 155.971 114.201"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M164.821 102.458C164.821 102.458 166.92 104.017 169.704 99.4732C172.35 95.1565 174.568 90.756 173.781 83.6454C173.781 83.6454 165.21 88.3548 164.309 93.3996C163.407 98.4447 164.821 102.458 164.821 102.458Z"
          fill="#8BB8F9"
        />
        <path
          d="M181.672 110.575C181.672 110.575 183.044 112.469 175.709 110.065C168.783 107.795 169.08 108.408 169.08 108.408C169.08 108.408 176.539 106.582 181.672 110.575Z"
          fill="white"
        />
        <path
          d="M164.996 106.225C164.996 106.225 165.254 108.065 169.284 109.404C173.313 110.742 179.471 108.652 181.672 110.575C181.672 110.575 176.369 105.628 164.996 106.225Z"
          fill="#8BB8F9"
        />
        <path
          d="M147.047 123.344C152.885 117.97 159.268 111.011 164.821 102.458C164.821 102.458 166.422 100.288 170.167 93.2768C173.913 86.2658 173.781 83.6454 173.781 83.6454"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M180.978 110.027C180.978 110.027 175.282 105.681 164.996 106.224C162.504 106.355 161.376 107.568 159.508 109.898"
          stroke="white"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M111.101 51.9979C113.1 51.9979 115.036 51.2962 116.571 50.0154L120.831 46.4613C122.363 45.1824 124.184 44.497 126.049 44.497H147.187C149.105 44.497 150.66 46.0521 150.66 47.9701V51.9976V124.495C150.66 127.805 147.977 130.488 144.667 130.488H39.2962C36.7218 130.488 34.6348 128.401 34.6348 125.827V56.6594C34.6348 54.085 36.7218 51.9979 39.2962 51.9979H111.101Z"
          fill="#00B0ED"
        />
        <path
          d="M34.6347 126.218C34.6347 126.218 41.8058 112.767 42.523 111.222L62.1214 71.2945C62.6141 70.2335 63.6774 69.5548 64.8472 69.5548H137.677C140.324 69.5548 144.154 68.1668 146.186 66.4704L149.125 64.0182C150.658 62.7393 152.479 62.0539 154.344 62.0539H174.46C176.601 62.0539 178.055 64.229 177.237 66.2079L152.913 125.04C151.549 128.338 148.332 130.489 144.764 130.489H35.95C35.2407 130.489 34.5856 129.881 34.5859 129.172L34.6347 126.218Z"
          fill="#B7DFF4"
        />
        <path
          d="M76.1078 82.9862H100.88C101.556 82.9862 102.184 82.6463 102.547 82.0849C103.384 80.7898 102.439 79.0947 100.88 79.0947H76.1078C75.4323 79.0947 74.8037 79.4346 74.4411 79.9956C73.6039 81.2911 74.5489 82.9862 76.1078 82.9862Z"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
        <path
          d="M122.448 102.198L103.16 113.689"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M106.678 101.645L118.797 113.76"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M115.961 118.419C123.68 116.284 128.631 109.825 127.017 103.992C125.404 98.1601 117.838 95.1631 110.118 97.2985C102.399 99.4339 97.4485 105.893 99.0618 111.725C100.675 117.558 108.241 120.555 115.961 118.419Z"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <clipPath id="clip0_659_12884">
            <rect
              width="16.0492"
              height="16.0493"
              fill="white"
              transform="translate(66.2031 4.64325)"
            />
          </clipPath>
        </defs>
      </svg>
      <p
        class="font-lato text-center text-taxpod-gray text-sm xlplus:text-base font-bold"
      >
        No File Conversions Yet
      </p>
      <p
        class="font-lato text-center text-taxpod-gray text-xs xlplus:text-sm font-normal"
      >
        Use the conversion tool to start converting your files.
      </p>
    </div>
  </div>
  }
</p-card>
